import { API } from "aws-amplify";
import { getBackgroundCheck } from "~/graphql/queries";
import { LoaderData } from "~/types";
import * as APITypes from "~/API";

export const EMPTY_BACKGROUND_CHECK_INFO: APITypes.BackgroundCheck = {
  id: "",
  startDate: "",
  endDate: "",
  __typename: "BackgroundCheck",
  status: APITypes.BackgroundCheckStatusType.Pending,
  createdAt: "",
  updatedAt: "",
  ownerID: "",
  ownerType: APITypes.OwnerType.User,
  _version: 0,
  _lastChangedAt: 0,
};

export const getBackgroundCheckInfo = async (
  leaseID: string
): Promise<LoaderData<APITypes.BackgroundCheck>> => {
  try {
    const response = (await API.graphql({
      query: getBackgroundCheck,
      variables: {
        id: leaseID,
      },
    })) as { data?: APITypes.GetBackgroundCheckQuery };

    return {
      success: true,
      data: response.data?.getBackgroundCheck || EMPTY_BACKGROUND_CHECK_INFO,
    };
  } catch (error) {
    return {
      success: false,
      data: EMPTY_BACKGROUND_CHECK_INFO,
      error,
    };
  }
};
